// Constantes para los selectores
export const TIPO_OPTIONS = [
  { value: 0, label: "Espacio Verde", key: "espacio_verde" },
  { value: 1, label: "Clínica/Hospital", key: "clinica_hospital" },
  { value: 2, label: "PH", key: "ph" }
];

export const IVA_OPTIONS = [
  { value: 0, label: "Sin Iva" },
  { value: 1, label: "Con Iva" }
];